import { BaseControl } from "../base-control";

class SelectControlCtrl extends BaseControl {
  constructor(BaseControlService, DomService, $scope) {
  'ngInject';
    super(BaseControlService, $scope);
    this.dom = DomService;
    this.optsInitialized = false;
  }

  async initializeControlData() {
    this.label = this.label || '\u200B';
    await super.initializeControlData();
    this.$scope.$applyAsync(async () => {
      // Value not in list, reset select
      if (!this.isPrint && this.model.value !== undefined && this.token.control.choices?.length && 
        !this.token.control.choices.find(ch => ch.value == this.model.value)) {
        this.clearModel();
      }
      this.allowNewChoices = this.token.fieldSchema.allowNewChoices;
      await this.applySelectPlugin();
      this.optsInitialized = true;
    });
  }

  modelChanged(newVal, oldVal) {
    super.modelChanged(newVal, oldVal);
    this.updateFlags();
    this.updateRelatedSelect(newVal);
  }

  updateFlags() {
    this.hasValue = ((this.model.value || '').toString().length) > 0;
  }

  updateRelatedSelect(newVal) {
    if (!this.optsInitialized || !newVal) return;
    // NOTE: this handles multiple instances of the same field:
    if (!this.token.control.choices.find(ch => ch.value == newVal)) {
      this.addCustomTempOpt(newVal);
      this.syncSelect2Change(newVal);
    }
  }
 
  async applySelectPlugin() {
    if (this.isPrint) return;
    await this.dom.waitForElement(`#${ this.token.id }-control`);

    $(`#${ this.token.id }-control`)
      .select2({ 
        allowClear: false, placeholder: this.label, tags: this.allowNewChoices,
        createTag: (params) => {
          const newVal = params.term;
          this.addCustomTempOpt(newVal);
          this.$timeout.cancel(this.debounceCustomValChange);
          this.debounceCustomValChange = this.$timeout(_ => this.syncSelect2Change(newVal), 500);
          return { id: newVal, text: newVal, newOption: true };
        }
      })
      .on('select2:select', e => this.syncSelect2Change(e?.params?.data?.text));
  }

  addCustomTempOpt(newVal) {
    this.token.control.choices = this.token.control.choices.filter(o => !o._temp);
    this.token.control.choices.push({ value: newVal, display: newVal, _temp: true });
  }

  clear() {
    this.syncSelect2Change('');
  }
  
  syncSelect2Change(value) {
    this.$timeout(_ => {
      $(`.token-id-${this.token.id} select.form-control`).val(`string:${value}`).trigger('change');
      this.$timeout(_ =>$(`.${this.referenceFieldId} select.form-control`).trigger('change'));
    });
  }
 
}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/select-control/select-control.component.html",
  controller: SelectControlCtrl
};